import React,{Component} from 'react';
import './Header.css';
import { Link,withRouter } from 'react-router-dom';

const url = "https://bikewale-login.onrender.com/api/auth/userinfo"

class Header extends Component{

    constructor(props){
        super(props)

        this.state={
            userData:''
        }
    }

    handleLogOut =() => {
        sessionStorage.removeItem('ltk')
        sessionStorage.setItem('loginStatus','logout');
        this.setState({userData:''})
        this.props.history.push('/')
    }

    conditionalHeader = () => {
        if(this.state.userData.name){
            let data =this.state.userData;
            let outArray = [data.name,data.email,data.phone];
            sessionStorage.setItem('userInfo',outArray)
            sessionStorage.setItem('loginStatus','login');
            return(
                <>
                    <button className="btn btn-success">
                    <span className="glyphicon glyphicon-user"></span> Hi {this.state.userData.name}
                    </button> &nbsp;
                    <button className="btn btn-danger"  onClick={this.handleLogOut}>
                        <span className="glyphicon glyphicon-log-out"></span> LogOut
                    </button>
                </>
            )
        }else{
            return(
                <>
                    <Link className="btn btn-success" to="/login">
                        <span className="glyphicon glyphicon-log-in"></span> LogIn
                    </Link> &nbsp;
                    <Link className="btn btn-danger"  to="/register">
                        <span className="glyphicon glyphicon-user"></span> SignUp
                    </Link>
                </>
            )
        }
    }

    render(){
        return(
            
        <header className="p-3  bg-dark text-white">
        <div id="navbar">
            <div className="container">
                <div className="d-flex flex-wrap align-items-center justify-content-center justify-content-lg-start">
                    <img className="navbar-button ms-0" height="17" src="https://mohit6795.github.io/Bikewale-Bootstrap/img/navbarbtn.png" alt="Navbarbtn" />
                    <a href="/" className="d-flex align-items-center  mb-lg-0 text-white text-decoration-none">
                        <img className="bi me-1 logobike" width="100" height="40" src="	https://mohit6795.github.io/Bikewale-Bootstrap/img/logo.png" alt="img"></img>
                    </a>
                    <ul className="nav col-12 col-lg-auto me-lg-auto mb-2 justify-content-center mb-md-0">
                        <li><a href="/" className="nav-link px-2 text-white">Home</a></li>
                        <li><a href="Feature.co" className="nav-link px-2 text-white">Features</a></li>
                        <li><a href="pricing.com" className="nav-link px-2 text-white">Pricing</a></li>
                        <li><a href="faq.com" className="nav-link px-2 text-white">FAQs</a></li>
                        <li><a href="about.com" className="nav-link px-2 text-white">About</a></li>
                    </ul>

                    <form className="col-12 col-lg-auto mb-3 mb-lg-0 me-lg-3">
                        <input type="search" className="form-control form-control-dark" placeholder="Search..." aria-label="Search" />
                    </form>

                 

                    <div className="text-end">
               {this.conditionalHeader()}
  
                    </div>
                </div>
            </div>
        </div>

    </header>

        )
    }

    componentDidMount(){
        fetch(url,{
            method: 'GET',
            headers:{
                'x-access-token':sessionStorage.getItem('ltk')
            }
        })
        .then((res) => res.json())
        .then((data) => {
            this.setState({
                userData:data
            })
        })

    }
}

export default withRouter(Header)